/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
import SingleChangelog from "../../../components-protocol-v4/Changelog/SingleChangelog";
export const meta = {
  id: 38,
  image: "default-changelog-v2.png",
  title: "Platform Improvements & Fixes",
  shortDescription: "We have released a new version of the Spheron platform with a couple of improvements and fixes.",
  description: "We have released a new version of the Spheron platform with a couple of improvements and fixes.",
  date: "July 17th, 2023",
  authorWithPositions: [{
    author: "Mitrasish Mukherjee",
    position: "Cofounder & Product Lead"
  }],
  keywords: ["Spheron"]
};
export const content = `

## Platform Improvements & Fixes

- **Pro package renewal:** Resolved the issue that was occurring when a renewal of PRO package was done and subscription was left in pending state.

- **Compute Marketplace:** Fixed the compute marketplace template page going blank for non-logged in users.

- **Switch App Dropdown:** Fixed the issue with switch app dropdown value inconsistent with the URL.

- **Billing Invoice:** Resolved the issue that the bonuses were not being displayed correctly on the invoice page.

- **IPFS Deployment Gateway:** Improved the architecture and performance of our IPFS and IPNS Gateway.

`;
const MDXLayout = ({children}) => _jsx(SingleChangelog, {
  meta: meta,
  children: content
});
function _createMdxContent(props) {
  return _jsx(_Fragment, {});
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
